import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { Block, P } from '@mote/ui'
import { ChevronDownIcon } from '@mote/assets/icons'
import { EDUCATION_NAV_LINKS } from '@mote/helpers/constants'
import { DashboardLayout } from '../../layouts'
import { Content } from './components'

const CARDS = [
  {
    key: 'learning-hub',
    icon: '🧠',
    text: 'Learning Hub',
    path: 'https://learn.mote.com/the-hub/',
    external: true
  },
  {
    key: 'support-center',
    icon: '🤝',
    text: 'Support Center',
    path: 'https://support.mote.com/hc/en-us',
    external: true
  },
  {
    key: 'suggest-feature',
    icon: '🎯',
    text: 'Suggest a feature',
    path: 'https://mote.canny.io/feature-requests',
    external: true
  },
  {
    key: 'community',
    icon: '🌈',
    text: 'Community',
    path: '/community'
  },
  {
    key: 'contact-us',
    icon: '✉️',
    text: 'Contact us',
    path: '/contact'
  },
  {
    key: 'careers',
    icon: '💼',
    text: 'Careers',
    path: '/careers'
  }
]

export const HelpAndSupport = () => {
  const history = useHistory()
  return (
    <DashboardLayout>
      <Content title='Help & Support' rows={2} columns={1} gap={24}>
        <Content type='section' rows={2} columns={3}>
          {CARDS.map(({ key, icon, text, path, external }) => {
            return (
              <Card
                key={key}
                layout='vertical'
                align='center'
                justify='center'
                gap={24}
                onClick={() => {
                  if (external) {
                    window.location.replace(path)
                  } else {
                    history.push(path)
                  }
                }}
              >
                <IconContainer role='img' aria-label='emoji'>
                  {icon}
                </IconContainer>
                <P
                  fontSize={19}
                  fontWeight={400}
                  lineHeight='120%'
                  color='#25252D'
                  alignment='center'
                >
                  {text}
                </P>
              </Card>
            )
          })}
        </Content>
        <StyledSection
          type='section'
          title='Useful Links'
          columns={2}
          gapY={12}
          gapX={24}
        >
          {EDUCATION_NAV_LINKS.filter(link => link.url !== '/community').map(
            ({ name, url }) => (
              <Link key={`nav-link--${name}:${url}`} href={url} text={name} />
            )
          )}
        </StyledSection>
      </Content>
    </DashboardLayout>
  )
}

const Link = ({ text, ...rest }) => {
  return (
    <StyledLink {...rest}>
      <span>
        {text}
        <ChevronDownIcon color='currentColor' height='0.75em' width='0.75em' />
      </span>
    </StyledLink>
  )
}

const Card = styled(Block)`
  min-height: 175px;
  padding: 24px;
  border-radius: 8px;
  background: #f6f6f9;
  cursor: pointer;
  transition: all 150ms ease-in;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: #ececf3;
    box-shadow: 0px 1px 3px rgba(113, 101, 129, 0.04),
      0px 3px 14px rgba(113, 101, 129, 0.08),
      0px 8px 32px rgba(113, 101, 129, 0.1);
  }

  @media (max-width: 639px) {
    min-height: unset;
    gap: 16px;
  }
`

const IconContainer = styled.span`
  font-size: 32px;
  line-height: 24px;
`

const StyledLink = styled.a`
  --link-padding: 16px;

  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: var(--link-padding);
  border-radius: 8px;
  background: transparent;
  background: #f6f6f9;
  transition: all 150ms ease-in;
  -webkit-tap-highlight-color: transparent;

  span {
    position: relative;
    width: calc(100% - var(--link-padding));
    font-size: 16px;
    line-height: 120%;
    color: #25252d;
    height: 100%;
    transition: all 150ms ease-in;

    svg {
      color: #ac0ae8;
      position: absolute;
      right: -1em;
      top: calc(50% - var(--link-padding) * 2);
      opacity: 0;
      visibility: hidden;
      transform: rotate(-90deg) translateX(calc(50% - var(--link-padding) * 2))
        translateY(-10px);
      transition: all 150ms ease-in;
    }
  }

  &:focus,
  &:hover {
    background: #ececf3;

    span {
      color: #ac0ae8;
    }
  }

  &:active {
    span {
      color: #7807a2;
      svg {
        color: inherit;
      }
    }
  }

  &:hover,
  &:focus,
  &:active {
    span {
      svg {
        opacity: 1;
        visibility: visible;
        transform: rotate(-90deg)
          translateX(calc(50% - var(--link-padding) * 2)) translateY(0);
      }
    }
  }
`

const StyledSection = styled(Content)`
  max-width: 750px;
`
